import {AfterViewInit, Component} from '@angular/core';
import {Handler} from "src/app/common/handler";
import {AppContext} from "../../../../app-context";
import {ExtendedUserProfile} from "@flowmaps-com/flowmaps-typescriptmodels";
import {Observable} from "rxjs";
import {View} from "../../../../common/view";
import {UserDetailsComponent} from "../user-details/user-details.component";

@Component({
  selector: 'app-users-overview',
  templateUrl: './users-overview.component.html',
  styleUrls: ['./users-overview.component.scss']
})
@Handler()
export class UsersOverviewComponent extends View implements AfterViewInit {
    appContext = AppContext;

    term: string;
    query: Observable<ExtendedUserProfile[]>;
    data: ExtendedUserProfile[] = [];

    ngAfterViewInit() {
        this.executeQuery();
    }

    executeQuery = () => {
        this.query = this.subscribeTo("searchExtendedUsers", this.term);
    }

    trackByForRecord = (index: number, record: ExtendedUserProfile): string =>
        record.profile?.userId ?? index.toString();

    createUser = () => this.openModal(UserDetailsComponent, {
        intermediaryId: AppContext.userProfile.intermediaryId,
        info: {
            language: AppContext.userProfile.info.language,
        },
        receivedAuthorisations: []
    });
}
